import clsx from 'clsx'
import CodeViewer from 'components/CodeViewer/CodeViewer'
import { formatJSON } from 'helpers/format'
import { TargetIcon } from 'lucide-react'
import { IPBlockList } from 'models/event'

import { IdentificationUrlKeys } from '../../../types'
import { SmartSignalDefinition } from './SmartSignalRepresentation'

export const torDefinition: SmartSignalDefinition<{ ip_blocklist?: { tor_node?: IPBlockList['tor_node'] } }> = {
  key: 'tor',
  urlParamKey: IdentificationUrlKeys.Tor,
  label: 'Tor',
  extract: (e) => ({ ip_blocklist: { tor_node: e.ip_blocklist?.tor_node } }),
  icon(e) {
    const p = this.extract(e)?.ip_blocklist?.tor_node
    return (
      <TargetIcon
        className={clsx('size-4', {
          'text-red-800': p,
        })}
      />
    )
  },
  details(e) {
    return (
      <CodeViewer
        value={formatJSON(this.extract(e))}
        withSearch={false}
        className={this.isDetected(e) ? 'bg-red-100 border-red-300' : 'bg-gray-100'}
      />
    )
  },
  isDetected(e) {
    const p = this.extract(e)?.ip_blocklist?.tor_node
    return p === true
  },
  isWeb: () => true,
  isMobile: () => true,
  searchFor: '"tor_node":',
  documentationHash: '#ip-blocklist-matching',
}
